import React from 'react'
export default () => [
  {
    title: '岗位',
    dataIndex: 'positionName',
    key: 'positionName',
    width: 150,
    align: 'center',
  },
  {
    title: '姓名',
    dataIndex: 'fullName',
    key: 'fullName',
    width: 150,
    align: 'center',
  },
  {
    title: '账号',
    dataIndex: 'userName',
    key: 'userName',
    width: 150,
    align: 'center',
  },
  // {
  //   title: '培训进度',
  //   dataIndex: 'trainingProgress',
  //   key: 'trainingProgress',
  //   width: 100,
  //   align: 'center',
  // },
  {
    title: '状态',
    dataIndex: 'trainingSituation',
    key: 'trainingSituation',
    width: 100,
    align: 'center',
    render: (text, row, index) => (text === 1 ? '不合格' : '合格')
  },
  {
    title: '手机号码',
    dataIndex: 'mobile',
    key: 'mobile',
    width: 150,
    align: 'center',
  },
  {
    title: '电子邮箱',
    dataIndex: 'email',
    key: 'email',
    width: 150,
    align: 'center',
  },
  {
    title: '稳定情况',
    dataIndex: 'stable',
    key: 'stable',
    align: 'center',
    width: 100,
    render: (text, record, index) => {
      let stateArr = ['稳定', '新增', '已删除']
      return (
        <span className={[2, 3].includes(text) ? 'unstable' : 'stable'}>
          {stateArr[text - 1]}
        </span>
      )
    },
  }
];
